export default {
  data() {
    return {
      // 当前页面
      currentPage: 1,
      //每页的数据
      pageLen: 15,
      //上传的文件
      fileListTwo: [],
      //上传的接口地址
      addressTwo: this.baseUrl + 'purchased/czUpload?token=' + this.$store.state.id,
      //下载模板地址
      download: this.baseUrl + 'excel/czUpload.xlsx',
      //搜索学生的条件
      searchStudent: {
        name: '',
        company: '',
        phone: '',
      },
      //辨别是用条件搜索还是全部搜索学生=>默认全部
      searchType: true,
      // 当前选择课程的学员id
      // studentId: '',
      //学生总数量
      studentTotal: 0,
      //学生搜素当前页
      studentSearchCurrentPage: 0,
      //学生当前页
      studentCurrentPage: 0,
      //学生数据
      studnetData: [],
      //所有产品
      selectData: [],
      // 控制显示根据身份证批量生成学时证明
      showIdcard: false,
      // 身份证号数组
      idcards: '',
      // id数组
      idList: [],
      // 判断输入的身份证号是否正确 0 错误 1 正确
      flag: null
    }
  },
  methods: {
    httpreq(q) {
      this.$upload(this.addressTwo, q).then(res => {
        // // console.log(res);
        if (res.status == "200") {
          this.$message({
            message: "上传成功！",
            type: "success"
          })
        }
      })
    },
    //该页每页要的数组
    handleSizeChange(val) {
      this.pageLen = val;
      this.getAllStudent();
    },
    //批量生成学时证明
    moreCreateCers() {
      if (this.paruseStudent.length == 0) {
        this.$message({
          message: "请至少选择一个成员",
          type: "error"
        });
        return false;
      }
      for (let id of this.paruseStudent) {
        this.createCers(id);
      }
    },
    //生成学时证明
    createCers(id) {
      //订单项
      let orderArr = [];
      //发送给后台的数据
      let data = {
        owner_id: id,
        purchased_cer_year: "0",
        score: "60",
        progress: "1",
        token: this.$store.state.authority_management,
        offset: "0",
        length: "999"
      }
      //请求有那些完成还没有生成的证书
      this.$post("purchased/shop_search_pay_all", data).then(res => {
        //获取的订单项赋值给orderArr变量
        // // console.log(res.data.result.data);
        orderArr = res.data.result.data;
        return res.data.result.data;
      }).then(data => {
        if (data) {
          //把年度合二为一
          for (let obj of orderArr) {
            this.$isAbnormal(obj.cer_year) ? obj.year = obj.is_first : obj.year = obj.cer_year;
          }
          let typeArr = [];
          //专业课年度数组
          let zhuanyeYear = [];
          //选修课年度数组
          let yeyuYear = [];
          //循环一遍已经完成但未生成证书订单项
          for (let item of orderArr) {
            if (item.attr == "专业课") {
              //把属性是专业课的不同年度添加到专业课年度数组
              zhuanyeYear.indexOf(item.year) == -1 ? zhuanyeYear.push(item.year) : zhuanyeYear;
            } else {
              //把属性是选修课的不同年度添加到专业课年度数组
              yeyuYear.indexOf(item.year) == -1 ? yeyuYear.push(item.year) : yeyuYear;
            }
          }
          //循环一遍把分组要发送的请求都组织好
          for (let val of zhuanyeYear) {
            let obj = {};
            obj.token = this.$store.state.id;
            obj.owner_id = id;
            obj.cer_year = val;
            obj.pay_date = "9999"
            obj.end_date = "1970"
            obj.purchased_id = [];
            for (let item of orderArr) {
              if (item.attr == "专业课" && item.year == val) {
                new Date(item.created_at).getTime() < new Date(obj.pay_date).getTime() ? obj.pay_date = item.created_at : obj.pay_date;
                new Date(item.updated_at).getTime() > new Date(obj.end_date).getTime() ? obj.end_date = item.updated_at : obj.end_date;
                obj.purchased_id.push(item.id);
              }
            }
            typeArr.push(obj);
          }
          //循环一遍把分组要发送的请求的都组织好
          for (let val of yeyuYear) {
            let obj = {};
            obj.token = this.$store.state.id;
            obj.owner_id = id;
            obj.cer_year = val;
            obj.pay_date = "9999";
            obj.end_date = "1970"
            obj.purchased_id = [];
            for (let item of orderArr) {
              if (item.attr == "选修课" && item.year == val) {
                new Date(item.created_at).getTime() < new Date(obj.pay_date).getTime() ? obj.pay_date = item.created_at : obj.pay_date;
                new Date(item.updated_at).getTime() > new Date(obj.end_date).getTime() ? obj.end_date = item.updated_at : obj.end_date;
                obj.purchased_id.push(item.id);
              }
            }
            typeArr.push(obj);
          }
          //序列化已经准备好的的订单项id数组
          for (let val of typeArr) {
            val.purchased_id = JSON.stringify(val.purchased_id);
          }
          //循环发送个人的请求
          // data of typeArr
          for (let i = 0; i < typeArr.length; i++) {
            this.$post("cers/shop_create", typeArr[i]).then(res => {
              //如果生成学时证明是最后一张了，就把订单项的证书状态改成已经生成
              if (i == typeArr.length - 1) {
                //声明订单项id数组
                let id_arr = [];
                //循环把id添加进去订单id数组
                for (let val of orderArr) {
                  id_arr.push(val.id);
                }
                //发送给后台的数据
                let data2 = {
                  token: this.$store.state.authority_management,
                  id_arr: JSON.stringify(id_arr),
                  cer_year: "1"
                }
                //把完成的证书改成已生成状态
                this.$post('purchased/updateCerYears', data2).then(res => {
                  if (res.data.status == "success") {
                    //返回成功提示
                    this.$message({
                      message: "生成学时证明成功",
                      type: "success"
                    })
                  }
                })
              }
            })
          }
        }
      })






    },

    //搜索课程
    searchClass() {
      this.$post('products/search', { token: this.$store.state.authority_management, offset: 0, length: 15, shop_id: 1, name: this.classSearchName, onsale: "1" }).then(res => {
        this.selectData = res.data.result.data;
        this.classTotal = res.data.result.total;
      })
    },

    downloadProgress: function () {
      // // console.log(this.download)
      window.open(this.download);
    },
    //确定搜索学生
    confirmSearch() {
      this.searchType = false;
      let obj = {
        token: this.$store.state.authority_management,
        company: this.searchStudent.company,
        name: this.searchStudent.name,
        phone: this.searchStudent.phone,
        offset: this.studentCurrentPage,
        length: 15
      };
      this.$post('users/search', obj).then(res => {
        this.studnetData = res.data.result.data;
        this.studentTotal = res.data.result.total;
      })
    },

    //获取学生信息详情
    getStudent() {
      //输入密码框隐藏
      this.isPassword = false;
      //弹出框显示
      this.dialogFormVisible = true
      //把输入框变为不可输入
      this.isInput = {
        name: true,
        idCard: true,
        phone: true,
        company: true,
        email: true,
      }
    },
    //点击学员多选框
    handleStudentChange(val) {
      let arr = [];
      for (let item of val) {
        arr.push(item.id);
      }
      this.paruseStudent = arr;
    },

    //点击当前页面获取该有的信息
    getClassPage(currentPage) {
      this.classCurrentPage = (currentPage - 1) * 15;
      this.allClass(this.studentId);
    },
    //获取所有学生的信息
    getAllStudent() {
      this.searchType = true;
      this.$post('users/search', { token: this.$store.state.authority_management, offset: this.studentCurrentPage, length: 15, shop_id: this.$store.state.store.id }).then(res => {
        this.studentTotal = res.data.result.total;
        this.studnetData = res.data.result.data;
      })
    },
    //根据分页获取学生信息
    getStudentPage(currentPage) {
      this.currentPage = currentPage;
      if (this.searchType) {
        //根据点击的分页改变数据的偏移量
        this.studentCurrentPage = (Number.parseInt(currentPage) - 1) * 15;
        //再请求对应的学生信息
        this.getAllStudent();
      } else {
        this.studentCurrentPage = (Number.parseInt(currentPage) - 1) * 15;
        this.confirmSearch()
      }

    },
    //上传的一堆回调方法
    beforeUploadTwo(file) {
      let str = file.name;
      // // console.log(file);
      if (str.substr(str.length - 4, 4).toLocaleLowerCase() != "xlsx") {
        alert('excel文件必须是xlsx格式')
        return false;
      }
    },
    handleRemoveTwo(file, fileList) {
      // // console.log(file, fileList);
    },
    handlePreviewTwo(file) {
      // // console.log(file);
    },
    handleExceedTwo(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemoveTwo(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    isOkTwo(response, file, fileList) {
      alert(response);
    },

    // 显示根据身份证批量生成学生证明弹窗
    showIdcardDialog() {
      this.showIdcard = true
    },

    // 取消批量生成证明
    colseGenerateProve() {
      this.showIdcard = false
      this.idcards = ''
    },

    // 批量生成学生证明
    generateProve() {
      // this.showIdcard = false
      if (this.idcards.trim() === '') {
        this.$message({
          type: 'error',
          message: '最少输入一个身份证号'
        })
        return
      }
      let idcard_arr = this.idcards.trim().split('\n')

      // 检查输入的身份证是否有误
      // for (let i = 0; i < idcard_arr.length; i++) {
      //   this.getUserByIdcard(idcard_arr[i])
      //   if (this.flag === 0) {
      //     break
      //   }
      // }

      // 根据身份证号获取id
      this.getIdByIdcard(idcard_arr)
    },

    // 根据身份证号数组获取id数组
    getIdByIdcard(idcard_arr) {
      this.$post('users/idcard_arr_id', {
        token: this.$store.state.authority_management,
        offset: 0,
        length: 9999,
        idcard_arr: JSON.stringify(idcard_arr)
      }).then(res => {
        // // console.log(res)
        if (res.data.result.total !== idcard_arr.length) {
          this.$message({
            type: 'error',
            message: '您输入的身份证信息有误, 请重新输入'
          })
          return
        }
        let list = res.data.result.data
        list.map(i => {
          this.idList.push(i.id * 1)
        })
        this.idList.map(i => {
          this.createCers(i)
        })
        this.idcards = ''
      })
    },

    // 根据身份证获取用户
    getUserByIdcard(idcard) {
      this.$post('users/user_by_idcard', {
        token: this.$store.state.authority_management,
        offset: 0,
        length: 9999,
        idcard: idcard
      }).then(res => {
        // // console.log(res)
        // 判断根据输入的身份证是否能查到用户
        if (res.data.result.data.length === 0) {
          this.$message({
            type: 'error',
            message: `输入的身份证号: ${idcard} 有误, 请检查后输入`
          })
          this.flag = 0
          // // console.log(this.flag)
        }
      })
    }
  },
  created() {
    this.getAllStudent();
  }

}
